import React from "react";
import {
  WrenchScrewdriverIcon,
  RectangleStackIcon,
  GlobeAltIcon,
} from "@heroicons/react/24/solid";

const ToolInfo = () => {
  const features = [
    {
      title: "Easy Setup",
      description:
        "Unlike other printers that can be complicated to set up, the Wall Pen offers a quick and intuitive assembly process, allowing users to start printing with minimal effort.",
      icon: <WrenchScrewdriverIcon className="w-8 h-8 text-white" />,
    },
    {
      title: "White Underlay",
      description:
        "Wall Pen’s innovative white underlay ensures that colors are vivid and accurate, even on dark or colorful surfaces, delivering consistent, professional results every time.",
      icon: <RectangleStackIcon className="w-8 h-8 text-white" />,
    },
    {
      title: "Any Surface",
      description:
        "Whether you’re printing on glass, brick, steel, wood, or drywall, the Wall Pen guarantees a flawless outcome with ease. wallPen ink is durable, scratch-resistant, and water-resistant.",
      icon: <GlobeAltIcon className="w-8 h-8 text-white" />,
    },
  ];

  return (
    <div className="bg-primary text-white py-6">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white text-black px-6 py-4 rounded-lg shadow-md flex flex-col items-start"
            >
              <div className="w-12 h-12 bg-orange-500 flex items-center justify-center rounded-full mb-4">
                {feature.icon}
              </div>
              <h3 className="font-bold text-primary text-lg mb-2">
                {feature.title}
              </h3>
              <p className="text-sm">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ToolInfo;
